import { Table } from 'antd';
import styled from 'styled-components';

const BorderedStyledTable = styled(Table)`
  &&& {
    .ant-table {
      border: none;
      border-radius: 0;
      background: transparent;
    }

    .ant-table-tbody > tr {
      background: transparent;
    }

    .ant-table-container {
      border: none !important;
    }

    .ant-table-thead > tr > th {
      font-family: var(--font-bold);
      text-transform: uppercase;
      font-size: 12px;
      letter-spacing: 0.5px;
      color: var(--text-primary);
      background: var(--white);
      border: none !important;
      border-bottom: none !important;
      border-inline-end: none !important;
      padding: 12px 16px;
    }

    .ant-table-thead > tr > th.ant-table-cell::before {
      display: none;
    }

    .ant-table-tbody > tr > td {
      padding: 10px 16px;
      border-bottom: 1px solid var(--line-gray);
      vertical-align: middle;
      background: var(--white);
      min-height: 60px;
    }

    .ant-table-tbody > tr > td:first-child {
      border-left: 1px solid var(--line-gray);
    }

    .ant-table-tbody > tr > td:last-child {
      border-right: 1px solid var(--line-gray);
    }

    .ant-table-tbody > tr:first-child > td {
      border-top: 1px solid var(--line-gray);
    }
  }
`;

export default BorderedStyledTable;
